export default "__VITE_ASSET__CmP7IySK__"